<template>
  <admin-base
    add-btn-text="Add New Role"
    :add-btn-permission="addRolePermission"
    @create="showModalForm"
    @search="(val) => (search = val)"
  >
    <admin-roles-table
      ref="table"
      :search="search"
      @edit="showModalForm"
      @delete="showDeleteDialog"
    />
    <anchor-confirm-dialog
      :title="`Are you sure you want to delete ${roleName} role?`"
      max-width="600"
      @confirm="deleteRole"
      @cancel="clearRole"
      ref="deleteRoleDialog"
    />
    <admin-roles-modal-form ref="modalForm" @success="refreshTable" />
  </admin-base>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import AdminBase from '@/components/admin/Base';
import AdminRolesTable from '@/components/admin/controls/roles/RolesTable';
import AdminRolesModalForm from '@/components/admin/controls/roles/form/RolesModalForm';

export default {
  name: 'AdminControlsRolesView',
  components: {
    AdminBase,
    AdminRolesTable,
    AdminRolesModalForm,
  },
  data: () => ({
    search: null,
    roleToDelete: undefined,
  }),
  computed: {
    addRolePermission: vm => vm.$permissions.ADD_ROLES,
    roleName: vm => vm.roleToDelete?.title,
  },
  methods: {
    showModalForm(role) {
      this.$refs.modalForm.open(this.$utils.deepCopy(role));
    },
    showDeleteDialog(role) {
      this.$refs.deleteRoleDialog.open();
      this.roleToDelete = role;
    },
    refreshTable() {
      this.$refs.table.fetch();
    },
    clearRole() {
      this.roleToDelete = undefined;
    },
    deleteRole() {
      this.$requests
        .delete(`/v1/roles/${this.roleToDelete._id}`)
        .then(() => {
          this.$toast.success(`Deleted role ${this.roleToDelete.title}`, { timeout: 3000 });
          this.refreshTable();
        })
        .catch(err => {
          this.$toast.error(err.response.data.message || `Could not delete ${this.roleToDelete.title}...`, {
            timeout: 3000,
          });
        });
    },
  },
};
</script>
